module.exports = __webpack_public_path__ + "static/media/CosAssessmentsGovtChecklist.68e5665d.png";